import React, { useState } from 'react';
import DashboardNavBar from './DashboardNavBar';
import MainDashboardPageStyles from "./MainDashboardPage.module.css";
import UserPics1 from "../../Assets/dashboard/user-pics-1.png";
import UserPics2 from "../../Assets/dashboard/user-pics-2.png";
import UserPics3 from "../../Assets/dashboard/user-pics-3.png";
import UserPics4 from "../../Assets/dashboard/user-pics-4.png";
import UserPics5 from "../../Assets/dashboard/user-pics-5.png";
import UserPics6 from "../../Assets/dashboard/user-pics-6.png";
import UserPics7 from "../../Assets/dashboard/user-pics-7.png";
import UserPics8 from "../../Assets/dashboard/user-pics-8.png";
import UserPics9 from "../../Assets/dashboard/user-pics-9.png";
import UserPics10 from "../../Assets/dashboard/user-pics-10.png";
import ProfileView from './ProfileView';

const MainDashboardPage = ({ sethamburgerMenu }) => {

    const [profileTab, setprofileTab] = useState("profile-inactive");

    return (
        <div className={MainDashboardPageStyles.DashboardCont}>
            <DashboardNavBar sethamburgerMenu={sethamburgerMenu} />

            {profileTab === "profile-inactive" && <div className={MainDashboardPageStyles.MainDashboardPageGrid}>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics1} alt="UserPics1" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics2} alt="UserPics2" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics3} alt="UserPics3" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics4} alt="UserPics4" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics5} alt="UserPics5" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics6} alt="UserPics6" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics7} alt="UserPics7" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics8} alt="UserPics8" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics9} alt="UserPics9" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics10} alt="UserPics10" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics5} alt="UserPics5" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics6} alt="UserPics6" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics7} alt="UserPics7" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics8} alt="UserPics8" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
                <div className={MainDashboardPageStyles.UserPics}>
                    <div><img src={UserPics9} alt="UserPics9" /></div>
                    <div className={MainDashboardPageStyles.UserDetails}>
                        <p>Hanifa Owuri</p>
                        <p>Abuja</p>
                        <p onClick={() => setprofileTab("profile-active")}>view</p>
                    </div>
                </div>
            </div>
            }
            {
                profileTab === "profile-active" && <ProfileView setprofileTab={setprofileTab} />
            }
        </div>
    )
}

export default MainDashboardPage
